/**
 * https://marshallku.com/web/tips/react%EC%97%90%EC%84%9C-dialog-%EB%A7%8C%EB%93%A4%EA%B8%B0
 */

import { create } from 'zustand';

type ResponseHandler<T = unknown> = (value: T | PromiseLike<T>) => void;
type DialogType = "alert" | "confirm" | "prompt";

interface DialogStore<T = unknown> {
    description: string;
    message: string;
    setDescription(description: string): void;
    setMessage(message: string): void;
    type: DialogType;
    setType(state: DialogType): void;
    revealed: boolean;
    setRevealed: (show: boolean) => void;
    responseHandler?: ResponseHandler<T>;
    setResponseHandler(responseHandler: ResponseHandler<T>): void;
}

export default create<DialogStore>((set) => ({
    description: "",
    message: '',
    setDescription(description) {
        set((prev) => ({ ...prev, description }));
    },
    setMessage(message) {
        set((prev) => ({ ...prev, message }));
    },
    type: "alert",
    setType(type) {
        set((prev) => ({ ...prev, type }));
    },
    revealed: false,
    setRevealed(revealed) {
        set((prev) => ({ ...prev, revealed }));
    },
    setResponseHandler(responseHandler) {
        set((prev) => ({ ...prev, responseHandler }));
    },
}))